import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAxiosAdmin from "../../lib/axiosAdmin";
import { SET_ALL_DATA_OF_ADMIN_USERS, SET_FILTERED_ADMIN_USERS, SET_PAGES_DATA_ADMIN_USERS, SET_SHOULD_UPDATE_ADMIN_USERS, SET_USERS_ADMIN_USERS } from "../../../../redux/action/admin/users/type";
import { toast } from "react-toastify";
import { SET_SHOULD_REFRESH_ADMIN_STAFF } from "../../../../redux/action/admin/staff/type"; // 🔥 اضافه شد

export default function useUsers() {

    const axiosAdmin = useAxiosAdmin();
    const accessToken = useSelector(state => state.auth.accessToken);

    const { users, filtered, page, pages, total, shouldUpdate } = useSelector(state => state.adminUsers); 
    
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");

    const [role, setRole] = useState(() => localStorage.getItem("users-role") || "all"); 
    const [sort, setSort] = useState(() => localStorage.getItem("users-sort") || "newest");
    const firstFilterRun = useRef(true);

    const [loadingMore, setLoadingMore] = useState(false);
    const [initialLoaded, setInitialLoaded] = useState(false);
    const [hasMore, setHasMore] = useState(false);

    const fetchUsers = async (searchValue = "", roleValue = role, sortValue = sort, pageNumber = 1) => {

        if (!accessToken) return;

        try {
            
            const isSearching = String(searchValue)?.trim() !== "";
            
            if (pageNumber === 1) {
                setLoading(true);
            } else {
                setLoadingMore(true);
            }

            let query = `?limit=${isSearching ? 1000 : 100}`;
            if (String(searchValue).trim() !== "") query += `&search=${String(searchValue)}`;
            if (roleValue !== "all") query += `&role=${roleValue}`;
            if (sortValue) query += `&sort=${sortValue}`;
            if (pageNumber) query += `&page=${pageNumber}`;

            const res = await axiosAdmin.get(`/api/admin/users${query}`);

            const data = res?.data || {};
            const newUsers = data?.users || [];

            const serverPage = data?.page || 1;
            const serverPages = data?.pages || 1;
            const serverTotal = data?.total || 0;
            
            dispatch({
                type: SET_PAGES_DATA_ADMIN_USERS,
                payload: {
                    page: serverPage,
                    pages: serverPages,
                    total: serverTotal
                }
            });

            // حالت ۱: در حال سرچ یا فیلتر هستیم → infinite غیرفعال
            if (isSearching || role !== 'all') {

                dispatch({
                    type: SET_FILTERED_ADMIN_USERS,
                    payload: newUsers
                });

                setHasMore(false);
                setInitialLoaded(true);
                return;
            }

            // حالت ۲: NO SEARCH → infinite scroll فعال
            if (pageNumber === 1) {

                // جایگزینی کامل داده‌ها
                dispatch({
                    type: SET_ALL_DATA_OF_ADMIN_USERS,
                    payload: {
                        ...data,
                        users: newUsers,
                    }
                });

                dispatch({
                    type: SET_FILTERED_ADMIN_USERS,
                    payload: newUsers
                });
            } 
            
            else {

                // append کردن به Admin.users
                dispatch({
                    type: SET_USERS_ADMIN_USERS,
                    payload: [...users, ...newUsers]
                });

                dispatch({
                    type: SET_FILTERED_ADMIN_USERS,
                    payload: [...filtered, ...newUsers]
                });

            }

            // وضعیت hasMore بر اساس page/pages
            setHasMore(serverPage < serverPages);

            setInitialLoaded(true);

        } catch (error) {

            const msg =
            error?.response?.data?.message ||
            error?.message ||
            "خطا در دریافت کاربران";

            toast.error(msg);
        }
        
        finally {
            setLoading(false);
            setTimeout(() => setLoadingMore(false), 300); // جلوگیری از دوبار لود شدن
        }

    };

    const isStaff = (user) => {
        return user?.role === "staff" || user?.roles?.includes("staff");
    };

    useEffect(() => {

        if (!accessToken) return;

        if (users.length > 0) {
            
            setLoading(false);

            if(shouldUpdate){
                
                fetchUsers();
                
                dispatch({
                    type: SET_SHOULD_UPDATE_ADMIN_USERS,
                    payload: false
                })

                return
            }

            dispatch({
                type: SET_FILTERED_ADMIN_USERS,
                payload: users
            });
            
            return;
        }

        fetchUsers();
    }, [accessToken]);

    // مدیریت filtered از طریق search
    useEffect(() => {

        if (!accessToken) return;

        if (search.trim() === "") {

            if(role !== 'all' || sort !== 'newest'){
                dispatch({
                    type: SET_FILTERED_ADMIN_USERS,
                    payload: filtered
                });
            }
            else {
                dispatch({
                    type: SET_FILTERED_ADMIN_USERS,
                    payload: users
                });
            }

            return;
        }

        const t = setTimeout(() => {
            fetchUsers(search, role, sort);
        }, 400);

        return () => clearTimeout(t);

    }, [search, users]);

    useEffect(() => {
        if (!accessToken) return;

        // جلوگیری از اجرا در بار اول
        if (firstFilterRun.current) {
            firstFilterRun.current = false;
            return;
        }
        
        // ذخیره در localStorage
        localStorage.setItem("users-role", role);
        localStorage.setItem("users-sort", sort);

        // بعد از بار اول → فیلتر را اجرا کن
        fetchUsers(search, role, sort);

    }, [role, sort]);

    const createUser = async (data) => {

        try {

            const res = await axiosAdmin.post("/api/admin/users", data);

            if (res?.status === 201 || res?.status === 200) {

                const newUser = res.data?.user || res.data;

                const updatedUsers = [newUser, ...users];
                const updatedFiltered = [newUser, ...filtered];

                dispatch({
                    type: SET_USERS_ADMIN_USERS,
                    payload: updatedUsers
                });

                dispatch({
                    type: SET_FILTERED_ADMIN_USERS,
                    payload: updatedFiltered
                });

                 // 🔥 اگر کاربر جدید staff بود، باید staff رو رفرش کنیم
                if (isStaff(newUser)) {
                    dispatch({
                        type: SET_SHOULD_REFRESH_ADMIN_STAFF,
                        payload: true
                    });
                }


                toast.success("کاربر با موفقیت اضافه شد");
            }

        }
        catch (error) {

            const message =
                error?.response?.data?.message ||
                error?.message ||
                "خطایی در ایجاد کاربر رخ داد";

            toast.error(message);

        }

    };

    const updateUser = async (id, data) => {
        
        try {
        
            const res =await axiosAdmin.put(`/api/admin/users/${id}`, data);

            if (res?.status === 200) {

                const updatedUser = res.data?.user || { id, ...data };

                 // 🔥 چک کنیم که آیا role تغییر کرده؟
                const oldUser = users.find(u => u._id === id);
                const wasStaff = isStaff(oldUser);
                const nowStaff = isStaff(updatedUser);

                const updatedUsers = users.map(user =>
                    user._id === id ? { ...user, ...updatedUser } : user
                );

                const updatedFiltered = filtered.map(user =>
                    user._id === id ? { ...user, ...updatedUser } : user
                );

                dispatch({
                    type: SET_USERS_ADMIN_USERS,
                    payload: updatedUsers
                });

                dispatch({
                    type: SET_FILTERED_ADMIN_USERS,
                    payload: updatedFiltered
                });


                // 🔥 اگر role تغییر کرده (staff شده یا از staff خارج شده)
                if (wasStaff !== nowStaff) {
                    dispatch({
                        type: SET_SHOULD_REFRESH_ADMIN_STAFF,
                        payload: true
                    });
                }

                toast.success("کاربر با موفقیت ویرایش شد");

            }
        
        }
        
        catch (error) {

            const message =
                error?.response?.data?.message ||
                error?.message ||
                "خطایی در ویرایش کاربر رخ داد";

            toast.error(message);
            
        }

    };

    const deleteUser = async (id) => {
        
        try{
            // 🔥 چک کنیم که آیا کاربر staff بود؟
            const userToDelete = users.find(u => u._id === id);
            const wasStaff = isStaff(userToDelete);

            const res = await axiosAdmin.delete(`/api/admin/users/${id}`);
            
            if (res?.status === 200) {
    
                const updatedUsers = users.filter(user => user._id !== id);
                const updatedFiltered = filtered.filter(user => user._id !== id);
    
                dispatch({
                    type: SET_USERS_ADMIN_USERS,
                    payload: updatedUsers
                });
    
                dispatch({
                    type: SET_FILTERED_ADMIN_USERS,
                    payload: updatedFiltered
                });

                // 🔥 اگر کاربر staff بود، باید staff رو رفرش کنیم
                if (wasStaff) {
                    dispatch({
                        type: SET_SHOULD_REFRESH_ADMIN_STAFF,
                        payload: true
                    });
                }

                toast.success("کاربر با موفقیت حذف شد");

            }

        }

        catch (error) {

            const message =
                error?.response?.data?.message ||
                error?.message ||
                "خطایی در حذف کاربر رخ داد";

            toast.error(message);
            
        }

    };

    return {
        users,
        loading,
        search,
        setSearch,
        createUser,
        updateUser,
        deleteUser,

        role,
        setRole,
        sort,
        setSort,

        loadingMore,
        hasMore,
        initialLoaded,

        fetchUsers
    };
}